import { ScrollSpyFixableTarget } from "./fixable"
import { ScrollSpySidebarTarget } from "./sidebar"

class ScrollSpyTargetFactory{
    static classes = {
        'fixable' : ScrollSpyFixableTarget,
        'sidebar' : ScrollSpySidebarTarget,
    }
    static factory(element, config){
        const target_type = config.target_type || 'fixable'
        const definedClass = this.classes[target_type]
        return new definedClass(element, config)
    }
}

export {
    ScrollSpyTargetFactory
}